<script setup>
defineProps({
  title: {
    type: String,
  },
  description: {
    type: String,
  },
  width: {
    type: String,
    default: null,
  },
  customBottomSpace: {
    type: String,
    default: null,
  },
  bottomBorder: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    class="page-header flex flex-wrap text-center justify-center mx-auto"
    :class="{
      'w-full container-text eight-col-max': !width || width === '',
      'w-full container-narrow': width === 'wide',
      'block-spacing': !customBottomSpace || customBottomSpace === '',
    }"
  >
    <div class="flex flex-col justify-center !w-full !max-w-full prose [&>nav>ol]:justify-center [&>nav]:!mb-3">
      <slot />
      <h1
        v-if="title"
        class="mb-4"
      >
        {{ title }}
      </h1>
      <p
        v-if="description"
        class="mt-0"
      >
        {{ description }}
      </p>
    </div>

    <hr
      v-if="bottomBorder"
      class="border-b-1 border-med-aqua mt-3 mb-8 w-full md:mb-10 lg:mt-4 lg:mb-14"
    >
  </div>
</template>
